import React, { Component } from 'react';
import './TabContent.css';
import _ from 'lodash';
import CanvasContent from './CanvasContent/CanvasContent';
import ColorList from './ColorList/ColorList';
import Resources from './Resources/Resources';
import CompetitorSelect from './CompetitorSelect/CompetitorSelect';
import { colors } from '../../constants';


class TabContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            circleData: [],
            competitorCheck: true,
            color: colors,
            prioritiser: [],
            changedNumberState: false,
            competitorSelectChecked: true,
            checkedData: []
        }
    }

    componentWillMount() {
        let groupedData = Object.values(_.groupBy(this.props.competeData, v => [v.groupId, v.segmentId].join()));
        let prioritiser = [];
        let checkedData = [];
        for (let arraysOfAbility of groupedData) {
            let i = arraysOfAbility[0];
            let segmentItem = _.find(this.props.customerSegmentData, (s) => s.groupId === i.groupId);
            let segmentName = segmentItem.segments.find(r => r.segmentId === i.segmentId).name;
            let value = _.find(this.props.resultData, (ii) => ii.segmentId === i.segmentId && ii.groupId === i.groupId) ? _.find(this.props.resultData, (ii) => ii.segmentId === i.segmentId && ii.groupId === i.groupId).value : 0

            let checked =  _.find(this.props.resultData, (ii) => ii.segmentId === i.segmentId && ii.groupId === i.groupId) &&  ( _.find(this.props.resultData, (ii) => ii.segmentId === i.segmentId && ii.groupId === i.groupId).checked !== undefined ) ? _.find(this.props.resultData, (ii) => ii.segmentId === i.segmentId && ii.groupId === i.groupId).checked : true;

            prioritiser.push({
                segmentId: i.segmentId,
                segmentName: segmentName,
                groupId: i.groupId,
                value: value,
                checked: checked,
            });
            checkedData.push(i.segmentId);

        }
        this.setState({ prioritiser, checkedData });
    }

    resourceChanges = (e, segmentItem) => {
        let value = e.target.value
        let currentSegment = this.state.prioritiser.find(r => r.groupId === segmentItem.groupId && r.segmentId === segmentItem.segmentId );
        currentSegment.value = value;
        this.setState({
            prioritiser: this.state.prioritiser,
            changedNumberState: true
        })
        this.props.getResultData(this.state.prioritiser)
    }

    changedNumber = () => {
        this.setState({changedNumberState : false})
    }

    competitorCheckChanges = (val) => {
        this.setState({ competitorCheck : val }, () => this.getCircleData(this.state.competitorCheck, this.state.checkedData))
    }

    competitorSelectCheckChanges = (val, segmentItem, checkedData) => {

        let currentSegment = this.state.prioritiser.find(r => r.groupId === segmentItem.groupId && r.segmentId === segmentItem.segmentId );
        currentSegment.checked = val;

        this.setState({
            prioritiser: this.state.prioritiser,
            checkedData
        }, () => this.getCircleData( this.state.competitorCheck , checkedData) );
        this.props.getResultData(this.state.prioritiser)
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1'/>
                    <div className='rect2'/>
                    <div className='rect3'/>
                    <div className='rect4'/>
                    <div className='rect5'/>
                </div>
            </div>
        );
    }

    getCircleData(competitorCheck, segmentIds) {
        let circleData = [];
        let groupedData = Object.values(_.groupBy(this.props.competeData, v => [v.groupId, v.segmentId].join()));
        for (let arraysOfAbility of groupedData) {
            let i = arraysOfAbility[0];
            let totalScore = _.sumBy(arraysOfAbility, 'totalScore');
            let segmentItem = _.find(this.props.customerSegmentData, (s) => s.groupId === i.groupId);
            let segmentPercent = segmentItem.segments.find(r => r.segmentId === i.segmentId).percent;
            let segmentName = segmentItem.segments.find(r => r.segmentId === i.segmentId).name;

            // Our Product Cycle
            circleData.push({
                segmentId: i.segmentId,
                groupId: i.groupId,
                value: totalScore,
                name: segmentName,
                key: circleData.length + 1,
                percent: segmentPercent,
            });


            // Competitors Cycles
            if(competitorCheck){
                let competitorsArray = [];
                for (let a of arraysOfAbility) {
                    competitorsArray = competitorsArray.concat(a.competitorTotal)
                }
                let uniqCompetitors = Object.values(_.groupBy(competitorsArray, 'competitorId'));
                for (let competitorItems of uniqCompetitors) {
                    let competitor = competitorItems[0];
                    let competitorTotalScore = _.sumBy(competitorItems, 'value');
                    const alt = this.props.competitorsGroupsData.find(r => r.competitorId === competitor.competitorId);
                    const totalScoreObj = this.props.segmentAttractiveness.attractivnessData.Items[0].segmentTotal.find(r => r.segmentId === i.segmentId);
                    circleData.push({
                        segmentId: i.segmentId,
                        groupId: i.groupId,
                        value: competitorTotalScore,
                        name: alt ? alt.competitorName : '',
                        key: circleData.length + 1,
                        percent: segmentPercent,
                        competitorId: competitor.competitorId,
                        totalScore: (totalScoreObj && totalScoreObj.value) || 0
                    });
                }
            }

        }
        let finalData = [];
        for (let data of circleData) {
            let segment = segmentIds.includes(data.segmentId);
            if (segment) {
                finalData.push(data);
            }
        }
        return finalData;
    }

    getSegmentsIds = (checkedData) => {
        this.setState({ checkedData });
    }

    render() {
        let tabs = this.props.tabs.map((item,key) => {
            return (
                <li className="nav-item" key={`${item.groupId}`}>
                    <a data-toggle="tab" className={key === 0 ? "nav-link active show" :"nav-link"} href={`#${item.groupId}`} aria-controls={`${item.groupId}`} aria-selected="true">{item.groupName} </a>
                </li>)
        });

        let tabsContent = this.props.tabs.map((tabItem, key) => {
            let  circleData  = this.getCircleData( this.state.competitorCheck, this.state.checkedData);

            const groupId = this.props.tabs.find(r => r.groupId === tabItem.groupId).groupId;
            return(
                <div id={groupId} className={key === 0 ? "tab-pane fade show active tabContentdiv compete-tab-content": "tab-pane fade tabContentdiv compete-tab-content"} role="tabpanel" key={key}>
                    <div className="row">
                        { !_.isEmpty(this.props.segmentAttractiveness.attractivnessData.Items) &&
                        <div className="col-md-12">
                            <CanvasContent
                                circleData={circleData}
                                segmentAttractiveness={this.props.segmentAttractiveness}
                                groupId={groupId}
                            />
                            <ColorList
                                circleData={circleData}
                                groupId={groupId}
                            />

                            <Resources
                                resourceData={this.state.prioritiser}
                                prioritiser={this.state.prioritiser}
                                resourceChanges={this.resourceChanges}
                                changedNumberState={this.state.changedNumberState}
                                changedNumber={this.changedNumber}
                                groupId={groupId}
                            />
                            <CompetitorSelect
                                resourceData={this.state.prioritiser}
                                prioritiser={this.state.prioritiser}
                                groupId={groupId}
                                resourceChanges={this.resourceChanges}
                                competitorSelectCheckChanges={this.competitorSelectCheckChanges}
                                states={this.state}
                                checkedData={this.state.checkedData}
                                getSegmentsIds={this.getSegmentsIds}
                            />

                        </div>
                        }
                    </div>
                </div>
            )
        })

        return (
            <div className='criteria-tabs-content attractiveness-tab-content'>
                <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
                    {tabs}
                    {/* { !_.isEmpty(this.props.attractivnessData.Items) && this.addTabs(this.props.attractivnessData.Items[0].data)} */}
                </ul>
                <div className="tab-content benefitsTabcontent" id="myTabContent" >
                    {tabsContent}

                </div>
            </div>
        )
    }
}
export default (TabContent);



// WEBPACK FOOTER //
// ./src/components/Prioritizer/Result/TabContent/TabContent.jsx